import React from 'react';
import Icon from 'assets/icons/ReservationIcon';

const ReservationIconStyling = () => {
    const styles = {
        color: 'rgba(0, 0, 0, 0.87)',
        display: 'block',
        fill: 'rgba(255, 255, 255, 0.7)',
        height: '24px',
        left: '4px',
        margin: '12px',
        position: 'absolute',
        top: '0',
        transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
        userSelect: 'none',
        width: '24px',
    };

    const pathStyle = {
        stroke: 'none',
        strokeWidth: '24px',
    };

    return (
        <Icon style={ styles } pathStyle={ pathStyle } />
    );
};

export default ReservationIconStyling;



// WEBPACK FOOTER //
// ./src/components/layout/Menu/ReservationIcon.js